import { AnyAction } from "redux";
import { update, upload } from "../../../user";
import { Dispatch } from "react";
import { Result } from "../../../../interfaces";

export const UPLOAD_IMAGE_PROFILE_REQUEST = 'UPLOAD_IMAGE_PROFILE_REQUEST';
export const UPLOAD_IMAGE_PROFILE_SUCCESS = 'UPLOAD_IMAGE_PROFILE_SUCCESS';
export const UPLOAD_IMAGE_PROFILE_FAILURE = 'UPLOAD_IMAGE_PROFILE_FAILURE';
export const UPLOAD_IMAGE_PROFILE = 'UPLOAD_IMAGE_PROFILE';

interface ActionDefault<T> {
    type : string,
    payload  : T
}

interface ActionPagination<T> {
    type : string,
    payload  : T
}

const uploadDataRequest = () => {
    return {
        type: UPLOAD_IMAGE_PROFILE_REQUEST,
    };
};

const uploadDataSuccess = (data: any):ActionPagination<Result<any>> => {
    return {
        type: UPLOAD_IMAGE_PROFILE_SUCCESS,
        payload :data
    };
};

const uploadDataFailure = (error: any) => {
    return {
        type: UPLOAD_IMAGE_PROFILE_FAILURE,
        payload: error,
    };
};
const uploadImage = (data:any) => {
    return {
        type: UPLOAD_IMAGE_PROFILE,
        payload: data,
    };
}

export const UploadImageProfile = (file:File, userId:string)=>  {
    return async (dispatch: Dispatch<AnyAction>) => {
         dispatch(uploadDataRequest());
         try {
            const response = await upload(file);
            await update('users', userId, {
                avatar  : response.data.id
            });
            dispatch(uploadImage(response.data));
         } catch (error:any) {
             dispatch(uploadDataFailure(error.message));
         }
     };
 };
